import { generateToken } from './generate-token';

export const authSDK = {
    generateToken,
};
